export default "__VITE_ASSET__Bk6ZLFyR__"